const ARRAY_BUFFER = 1
const BINARY_STRING = 2
const DATA_URL = 3
const TEXT = 4

export default {

  read(file, type = ARRAY_BUFFER) {
    const reader = new FileReader()
    const promise = new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result)
      reader.onerror = () => reject(reader.error)
    })

    if (type === ARRAY_BUFFER) {
      reader.readAsArrayBuffer(file)
    } else if (type === BINARY_STRING) {
      reader.readAsBinarySring(file)
    } else if (type === DATA_URL) {
      reader.readAsDataURL(file)
    } else if (type === TEXT) {
      reader.readAsText(file)
    }

    return promise
  },

  readAsBlob(file) {
    return this.read(file)
      .then(buffer => new Blob([new DataView(buffer)], { type: file.type }))
  },

  readAsDataUrl(file) {
    return this.read(file, DATA_URL)
  },

}
